// extracted by mini-css-extract-plugin
export default {"wrapper":"PageTitle_wrapper__WvCy8","hasSubTitle":"PageTitle_hasSubTitle__bGhct","hasMarginBottom":"PageTitle_hasMarginBottom__WpoJv"};